import { MemoryStorage } from './memory.storage';
export class StorageManager {
    get prefix() {
        return this.config.storagePrefix ?? '';
    }
    get separator() {
        return this.config.storageSeparator ?? ':';
    }
    constructor(config) {
        this.config = config;
        this.storage = getStorage();
    }
    set(key, data) {
        try {
            const _key = this.key(key);
            const strData = typeof data !== 'string' ? JSON.stringify(data) : data;
            this.storage.setItem(_key, strData);
        }
        catch (error) {
            console.error(error);
        }
    }
    get(key, parser) {
        try {
            const _key = this.key(key);
            const strData = this.storage.getItem(_key);
            if (strData === null)
                return null;
            return parser(strData);
        }
        catch (error) {
            console.error(error);
            return null;
        }
    }
    remove(key) {
        try {
            const _key = this.key(key);
            this.storage.removeItem(_key);
        }
        catch (error) {
            console.error(error);
        }
    }
    update(key, updates) {
        const value = this.get(key, JsonParser);
        const newValue = updates(value);
        this.set(key, newValue);
        return newValue;
    }
    updateEntity(key, entityKey, value) {
        const entity = this.get(key, JsonParser) ?? {};
        const newEntity = { ...entity, [entityKey]: value };
        this.set(key, newEntity);
    }
    getEntityValue(key, entityKey) {
        const entity = this.get(key, JsonParser) ?? {};
        return entity[entityKey] ?? null;
    }
    key(rawKey) {
        return [this.prefix, rawKey].join(this.separator);
    }
}
function getStorage() {
    if (isSupportedStorage(window.localStorage)) {
        return window.localStorage;
    }
    if (isSupportedStorage(window.sessionStorage)) {
        return window.sessionStorage;
    }
    return new MemoryStorage();
}
const testKey = '@__test__@';
function isSupportedStorage(storage) {
    try {
        storage.setItem(testKey, '1');
        const item1 = storage.getItem(testKey);
        storage.removeItem(testKey);
        const item2 = storage.getItem(testKey);
        return item1 === '1' && item2 === null;
    }
    catch {
        return false;
    }
}
export function JsonParser(value) {
    return JSON.parse(value);
}
export const storage = new StorageManager({
    storagePrefix: 'one-inch',
    storageSeparator: ':',
});
//# sourceMappingURL=storage.manager.js.map